import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IModalReducer extends IModalAction{
  status?: 'finished' | 'error' | 'loading'
}

interface IModalGetter {
  modal: IModalReducer
}

interface IModalAction {
  isSessionWarningModalOpen: boolean
}

export type IModalType = 'warning' | undefined

export const modalSlice = createSlice({
  name: 'modal',
  initialState: {
    isSessionWarningModalOpen: false
    // TODO - move isMessageModalOpen to an enum here if we add another modal down the road (e.g. LiveChat Modal)
  },
  reducers: {
    setSessionWarningModal: (state: IModalReducer, action: PayloadAction<IModalAction>) => {
      state.isSessionWarningModalOpen = action.payload.isSessionWarningModalOpen
    }
  }
})

export const {
  setSessionWarningModal
} = modalSlice.actions

// GETTERS
export const getIsSessionWarningModalOpen = (state: IModalGetter) => state.modal.isSessionWarningModalOpen

export default modalSlice.reducer
